import { Injectable } from '@angular/core';
import {Resolve} from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {utilsUrl} from '../api-url';


@Injectable({
  providedIn: 'root'
})
export class UtilsResolver implements Resolve<any> {
  constructor(private http: HttpClient) { }
  resolve(): Observable<any> | Promise<any> | any {
    return this.http.get<any>(utilsUrl).pipe(
      map(data => data),
      catchError(err => err)
    );
  }
}
